import { Person } from "../../models/Person";
import { ServiceAccount } from "../../models/ServiceAccount";
import { Vehicle } from "../../models/Vehicle";
import { Sensor } from "../../models/Sensor";
import { runAction } from "../client";
import { Division } from "../../models/Division";
import { EntityType } from "../../models/EntityType";

export type SearchRequest = any & { Name: string };

export interface EntitySearchResult
{
	SearchTitle?: string;
    Entries: {
		Person?: Person[],
		ServiceAccount?: ServiceAccount[],
		Vehicle?: Vehicle[],
		Sensor?: Sensor[],
		Division?: Division[]
	},
	Success?: boolean,
	ErrorMessage?: string
}

export const getSearchName = (entityType: EntityType) => {
	switch(entityType) {
		case EntityType.Division:
			return 'Divisions';
		case EntityType.Person:
			return 'Persons';
		case EntityType.ServiceAccount:
			return 'ServiceAccounts';
		case EntityType.Vehicle:
			return 'Vehicles';
		case EntityType.Sensor:
			return 'Sensors';
	    default:
        	throw new Error(`search for entity type = ${entityType} is not implemented`);
	}
};

export interface SearchFn
{
    (request: SearchRequest): Promise<EntitySearchResult>;
}

export const runSearch: SearchFn = (request: SearchRequest): Promise<EntitySearchResult> => {
    return runAction<EntitySearchResult>('/action/Search', request);
}


// WEBPACK FOOTER //
// ./src/rest/Search/common.ts